import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CreateFormsService } from '@bo-client/activation-management/shared/forms/create-forms.service';
import { CreateFormsCommissioningService } from '@bo-client/activation-management/commissioning/forms/create-forms-commissioning.service';

@Component({
  selector: 'app-cr-submit-new-date-form',
  templateUrl: './cr-submit-new-date-form.component.html',
  styleUrls: ['./cr-submit-new-date-form.component.scss']
})
export class CrSubmitNewDateFormComponent
  implements CustomFormComponent<CommissioningRequestDtoModel, CommissioningRequestDtoModel>, OnInit
{
  @Input() data: DataForCustomFormModel<CommissioningRequestDtoModel>;
  @Output() onConfirm: EventEmitter<CommissioningRequestDtoModel> = new EventEmitter();

  public model: CommissioningRequestDtoModel;
  public currentForm: FormGroup;

  constructor(private createFormsService: CreateFormsCommissioningService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.model = this.data.model;

    this.currentForm = this.fb.group({
      date: [this.model.supplyAppointment, [Validators.required]],
      time: [this.model.supplyAppointment, [Validators.required]]
    });
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    if (this.currentForm.valid) {
      this.model.supplyAppointment = this.createFormsService.loadDateField(
        this.currentForm.get('date').value,
        this.currentForm.get('time').value
      );
      this.onConfirm.emit(this.model);
    } else {
      this.currentForm.markAllAsTouched();
    }
  }
}
